import {
	FacilityMaintenanceVendor,
	Model
} from ".";

export default class FacilityMaintenanceVendorType extends Model {
	get singularNoun() {
		return "vendor category";
	}

	get pluralNoun() {
		return "vendor categories";
	}

	get mutations() {
		return {
			vendors: FacilityMaintenanceVendor
		};
	}

	resource() {
		return "facility-maintenance/vendor-types";
	}
}
